<script>

/**
 * Automodal 
 * 
 * Version 1.4
 * Agrega el concepto haldeItem, que permite manipular los elementos del archetyipo independientemeente 
 * de si son arreglos de objetos o solo objetos.
 * 
 * Version 1.3
 * Remvue el concepto de archetype como prpoiedad por causar conflictos
 * Recomendado switch por item.key en cArchetype para evitar errores de ejecución.
 * 
 * Version 1.2
 * Corrige la actualización desde cArchetype automática de automodal. 
 * (Requiere "UI Edit automodal@1.10")
 * 
 * Version 1.1
 * Se pasa a ui-edit-auto-modal el parámetro :form-id, requerido para el control de borrado.
 * 
 * Version 1.0
 * Placeholder base
 */

import _ from 'lodash'
import presenciasQuickTable from '../Presencias/quicktable.vue'
import gruposQuicktable from '../Grupos/gruposQuicktable.vue'
import md5 from 'js-md5'
import BloqueodefechasQuicktable from '../Bloqueodefechas/BloqueodefechasQuicktable.vue'

import { archetype, automodalHandler } from './archetype'
import { GroupsFromSedesIDURI } from './../Grupos/archetype'
import {captionsForSelectedGroup, captionsForSelectedGroupEmpresa} from './../Presencias/archetype.js'

export default {
    name: 'cedesAutomodal',
    props: {
        conceptId: {
            type: [String, Number],
        }
    },
    components: { gruposQuicktable, presenciasQuickTable, BloqueodefechasQuicktable },
    data: () => {
        return {
            captionsForSelectedGroup,
            captionsForSelectedGroupEmpresa,
            form: {
                id: null
            },
            asides: {
                menu_clase: []
                // administradores: [],
                // distribuidores: [],
            }
        }
    },
    computed: {
        gruposURI() {
            return GroupsFromSedesIDURI(this.form.id)
        },
        formArchetypeMD5() {
            return md5(JSON.stringify(this.cArchetype))
        },
        cArchetype() {
            let updated = [];
            _.forEach(archetype(), itemsRow => {
                if (!_.isArray(itemsRow)) {
                    updated.push(this.handleItem(itemsRow));
                    return
                }
                let adding = []
                _.forEach(itemsRow, item => {
                    adding.push(this.handleItem(item))
                })
                updated.push(adding)
            })
            return updated
        }
    },
    methods: {
        handleItem(item) {
            // EVALUACIÓN DINÁMICA POR ELEMENTO DE ARQUETIPO
            if (_.isObjectLike(item)) {
                switch (item.key) {
                    case 'menu_clase':
                        item.options = _.clone(this.asides.menu_clase)
                        break;
                    case 'accesso':
                        item.readonly = (!_.isNil(this.form.id))
                        break;
                    default: 
                        break;
                }
            }
            return item;
        },
        getHandler() {
            return automodalHandler(this.conceptId)
        },
        refresh() {
            this.$emit('refresh');
        },
        checkAsides() {
            const asides = this.$refs.automodal.getAsides();
            if (!!asides) {
                this.asides.menu_clase = asides.menu_clase
                // this.asides.distribuidores = asides.distribuidores
            }
        },
        onDisplay() {
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL HA CARGADO DOM COMPLETAMENTE.
        },
        onHidden() {
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL SE HA OCULTADO
        },

    },
    watch: {
        'form.id'() {

        }
    }
}
</script>

<template>
    <ui-edit-auto-modal v-model="form" ref="automodal" label="Vista general de escuela o empresa"
        :size="(!!form.id) ? 'xl' : 'md'" 
        :form-id="form.id" 
        :form-archetype="cArchetype" 
        :handler="getHandler()" 
        :allow-aside="!!form.id"
        :allow-delete="true" 
        :form-key="formArchetypeMD5" 
        @refresh="refresh()" 
        @defined="checkAsides()" 
        @display="onDisplay" 
        @hidden="onHidden">
        <slot name="default"><i class="fa fa-cog"></i></slot>
        <b-col slot="aside" cols="9">
            <b-tabs>
                <b-tab title="Usuarios">
                    <!-- <grupos-quicktable :fetchingAPI="gruposURI" :sedes-id="form.id"  /> -->
                    <presencias-quick-table :cedes-id="form.id" tipo="directo" :captions="captionsForSelectedGroupEmpresa" />
                </b-tab>
                <b-tab v-if="form.cede_tipo == 'escuela'" title="Grupos">
                    <grupos-quicktable :fetchingAPI="gruposURI" :sedes-id="form.id" />
                </b-tab>
                <b-tab title="Bloqueo de fechas">
                    <bloqueodefechas-quicktable key="singular" allow-new :sedes-id="form.id" :fetchingAPI="'bloqueodefechas/sedesfiltered/' + form.id" />
                </b-tab>
            </b-tabs>
            <!-- LATERAL, REQUIERE :allow-aside="true" -->
        </b-col>
        <b-col slot="bottom" v-if="false">
            <!-- AGREGAR AL FONDO... -->
        </b-col>
    </ui-edit-auto-modal>
</template>